/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import {
  homeAddressCodeList,
  homeAddressLookup,
  homeAddressLookupManual,
  homeCreateQuote, homeDocumentsSummary, homeRenewalDocuments,
  homeRenewalRetrieve, targetGateway
} from '../constants/apiRequest/requestConstants/endpoints';
import { isAnalyticsEnabled } from '../constants/commonConstants';
import { sendAnalyticsEvent } from '../helpers';
import { makeRequest } from '../helpers/makeApiRequest';
import type {
  AppliedDocument,
  AppliedDocumentGroup,
  AppliedGroupedDocumentsRequest,
  DocumentSummaryRequest,
  RenewalQuoteResponseModel
} from '../types/Home';

export const getRenewalQuote = async (
  // eslint-disable-next-line flowtype/no-weak-types
  homeRenewalData: any,
  // eslint-disable-next-line no-unused-vars, flowtype/no-weak-types
  match: any,
  // eslint-disable-next-line no-empty-pattern, flowtype/no-weak-types
  {  }: any
): Promise<RenewalQuoteResponseModel[] | { error?: boolean }> => {
  const quoteRequest = makeRequest({
    method: 'POST',
    url: `${targetGateway()}${homeRenewalRetrieve}`,
    payload: homeRenewalData
  });

  return await quoteRequest;
};

export const postHomeQuote = async (
  // eslint-disable-next-line flowtype/no-weak-types
  homeQuoteData: any,
  // eslint-disable-next-line flowtype/no-weak-types
  props: any = {}
) => {
  const quoteRequest = await makeRequest({
    method: 'POST',
    url: `${targetGateway()}${homeCreateQuote}`,
    payload: homeQuoteData,
    history: props.history
  });

  if (isAnalyticsEnabled) {
    sendAnalyticsEvent(quoteRequest, 'insuranceEvent', 'Home');
  }
  return quoteRequest;
};

export const getAppliedAddress = async (
  // eslint-disable-next-line flowtype/no-weak-types
  payloadObj: any,
  manual: boolean = false
) => {
  const quoteRequest = makeRequest({
    method: 'POST',
    url: manual ? homeAddressLookupManual : homeAddressLookup,
    payload: {
      ...payloadObj
    }
  });

  return await quoteRequest;
};

export const getTownAndCounty = async () => {
  return makeRequest({
    method: 'GET',
    url: homeAddressCodeList
  });
};

export const getRenewalDocumentLinks = async (
  payload: DocumentSummaryRequest
): Promise<AppliedDocument[]> => {
  const response = await makeRequest({
    url: homeRenewalDocuments,
    method: 'POST',
    payload
  });

  return response?.error ? [] : response;
}

export const getHomeDocumentLinks = async (
  payload: AppliedGroupedDocumentsRequest
): Promise<AppliedDocumentGroup[]> => {
  const response = await makeRequest({
    url: homeDocumentsSummary,
    method: 'POST',
    payload
  });

  return response?.error ? [] : response;
}
